export default __webpack_public_path__ + "static/media/horse.24a41628.svg";